/**
 * @generated SignedSource<<cd6b558cbe07ef4718a3239b72618ce9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GeneratePromptFeedbackInput = {
  jobRunId: any;
};
export type GeneratePromptFeedbackMutation$variables = {
  input: GeneratePromptFeedbackInput;
};
export type GeneratePromptFeedbackMutation$data = {
  readonly generatePromptFeedback: {
    readonly error: {
      readonly message: string;
    } | null | undefined;
    readonly success: {
      readonly promptFeedback: {
        readonly id: any;
        readonly suggestions: ReadonlyArray<{
          readonly explanation: string;
          readonly isStale: boolean;
          readonly name: string;
          readonly suggestedPrompt: string;
        }>;
      };
    } | null | undefined;
  };
};
export type GeneratePromptFeedbackMutation = {
  response: GeneratePromptFeedbackMutation$data;
  variables: GeneratePromptFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GeneratePromptFeedbackResponse",
    "kind": "LinkedField",
    "name": "generatePromptFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneratePromptFeedbackSuccess",
        "kind": "LinkedField",
        "name": "success",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLPromptFeedback",
            "kind": "LinkedField",
            "name": "promptFeedback",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLPromptSuggestion",
                "kind": "LinkedField",
                "name": "suggestions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "suggestedPrompt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "explanation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isStale",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneratePromptFeedbackError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GeneratePromptFeedbackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GeneratePromptFeedbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "68756033f381c287fda7c2f9f24151a7",
    "id": null,
    "metadata": {},
    "name": "GeneratePromptFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation GeneratePromptFeedbackMutation(\n  $input: GeneratePromptFeedbackInput!\n) {\n  generatePromptFeedback(input: $input) {\n    success {\n      promptFeedback {\n        id\n        suggestions {\n          name\n          suggestedPrompt\n          explanation\n          isStale\n        }\n      }\n    }\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e52760597b4eda72d49d69419f61ba41";

export default node;
